<template>
    <div class="page-wrapper">
        <div class="flow-chart-page-top">
            <a class="return" @click="backToList">&lt; 返回</a>
            <span>RPA: </span>
            <el-tooltip :content="rpaName" placement="top">
                <span class="title-name" v-show="!showEdit">{{ rpaName || "未命名" }}</span>
            </el-tooltip>
            <el-input
                v-show="showEdit"
                class="input"
                :class="{ unvalid: !isValid.result }"
                ref="titleInput"
                v-model="rpaNameEdit"
                :placeholder="rpaName"
                @keypress="keyPressHandler"
                @blur="updateRpaName"
            ></el-input>
            <span class="validationTips" v-show="showEdit">{{ isValid.validationTips }}</span>
            <i class="edit" v-show="!showEdit" @click="titleEdit" />
        </div>
        <div class="flow-chart-page-banner">
            <div class="flow-auto-sort">
                <span class="pre-num">{{ radio }}%</span>
                <span @click="scaleAct(10)">
                    <i class="icon-wrapper ico-enlarge el-icon-zoom-in" />
                </span>
                <span @click="scaleAct(-10)">
                    <i class="icon-wrapper ico-narrow el-icon-zoom-out" />
                </span>
                <span class="auto-format" @click="formatFlow(true)">自动整理</span>
            </div>
            <div class="add-node-options">
                <el-dropdown split-button trigger="click">
                    新增节点
                    <el-dropdown-menu slot="dropdown" class="add-node-menu">
                        <el-dropdown-item v-for="item in nodeOptions" :key="item.value" @click.native="addNode(item)">{{
                            item.label
                        }}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <div class="flow-outer">
            <FlowChart
                ref="chart"
                class="flow-chart"
                :containerId="container"
                :nodeTypes="nodeTypes"
                :nodes="nodes"
                :connectors="connectors"
                @nodeClick="nodeClick"
                @chartChange="chartChange"
            />
        </div>
        <div class="flow-chart-page-bottom">
            <el-button type="primary" round @click="submitOnline">
                上线
            </el-button>
            <el-button class="btn-keep" type round @click="saveHandle">
                保存为草稿
            </el-button>
            <el-button class="btn-cancel" type round @click="backToList">
                取消
            </el-button>
        </div>
    </div>
</template>
<script>
import FlowChart from "./flowChart/Chart";
import nodeTypes from "./nodes";
import { queryRpaDetail, addRpaNode, updateRpaFlow, deleteRpaNode, updateRpaStatus } from "./service";
import i18n from "@/i18n";

export default {
    components: {
        FlowChart
    },
    data() {
        return {
            container: "chartcontainer",
            nodes: [],
            connectors: [],
            showEdit: false, // 是否显示编辑按钮
            rpaName: "", // rpa-name
            rpaNameEdit: "",
            radio: 100,
            rpaId: "",
            nodeOptions: nodeTypes.map(n => ({ label: n.label, value: n.nodeType }))
        };
    },
    computed: {
        nodeTypes() {
            return nodeTypes.map(nType => {
                nType.init = async () => await this.nodeInit(nType);
                return nType;
            });
        },
        isValid() {
            const newEditVal = this.zhiji.strTrim(this.rpaNameEdit)
            if (newEditVal.search(/[<>]/g) !== -1) {
                return {
                    validationTips: "名称不可携带<>,会有xss安全风险",
                    result: false,
                }
            } else if (newEditVal === "") {
                return {
                    validationTips: "请输入RPA名称",
                    result: false,
                }
            }
            return {
                validationTips: "",
                result: true,
            };
        }
    },
    created() {
        this.rpaId = this.$route.query.rpaId;
    },
    mounted() {
        queryRpaDetail(this.rpaId).then(resp => {
            this.init(resp);
        });
    },
    methods: {
        async addNode(option) {
            const initData = await this.nodeInit({ nodeType: option.value });
            this.$refs.chart.addNode({ ...initData, nodeType: option.value, position: { x: 40, y: 20 } });
        },
        commonSubmit(status, hint) {
            updateRpaStatus({
                rpaIds: this.rpaId,
                status,
            }).then(res => {
                if (res.rpa_id) {
                    this.$message({
                        message: i18n.t(`zhiji.rpa.${hint}`),
                        type: "success"
                    });
                }
            });
        },
        submitOnline() {
            this.commonSubmit(1, "onlineSuccess");
        },
        saveHandle() {
            this.commonSubmit(0, "draftSuccess");
        },
        scaleAct(scale) {
            // 限制放大范围 10-200
            if ((scale < 0 && this.radio > 10) || (scale > 0 && this.radio < 200)) {
                this.radio += scale;
                this.$refs.chart.setZoom(this.radio / 100);
            }
        },
        async updateRpaName() {
            const newTitle = this.zhiji.strTrim(this.rpaNameEdit);
            const isChanged = newTitle != this.rpaName;
            if (isChanged && this.isValid.result) {
                this.rpaName = newTitle;
                const datas = this.$refs.chart.getAll(); // 触发更新
                await updateRpaFlow({ rpaId: this.rpaId, ...datas, rpaName: this.rpaName });
            }
            this.showEdit = false;
        },
        keyPressHandler(event) {
            const isEnterKey = event.keyCode === 13;
            isEnterKey && this.updateRpaName();
        },
        titleEdit() {
            this.showEdit = true;
            this.rpaNameEdit = this.rpaName;
            this.$nextTick(() => {
                this.$refs.titleInput && this.$refs.titleInput.focus();
            });
        },
        init({ nodes, connectors, rpaName }) {
            this.$refs.chart.init(nodes, connectors);
            this.rpaName = rpaName;
        },
        async nodeInit({ nodeType }) {
            const { id } = await addRpaNode({ rpaId: this.rpaId, nodeType });
            return { id, name: "", rpaId: this.rpaId };
        },
        async nodeClick({ node, operator }) {
            if (operator === "delete") {
                this.deleteNode(node);
            } else if (operator === "edited") {
                queryRpaDetail(this.rpaId).then(({ nodes, connectors }) => {
                    this.$refs.chart.updateAll(nodes, connectors);
                });
            }
        },
        deleteNode(node) {
            const nodeOption = this.nodeOptions.find(nop => nop.value === node.nodeType);
            this.$store.dispatch("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "tip",
                    message: `您确认删除${nodeOption.label}节点“${node.name || "未命名"}”吗？`,
                    confirm: async () => {
                        await deleteRpaNode({ rpaId: this.rpaId, nodeId: node.id });
                        this.$refs.chart.deleteNode(node);
                    }
                }
            });
        },
        chartChange(datas) {
            this.updateTimeout && clearTimeout(this.updateTimeout);
            this.updateTimeout = setTimeout(async () => {
                const isSaved = await updateRpaFlow({ rpaId: this.rpaId, ...datas, rpaName: this.rpaName });
                const hint = isSaved.rpa_id ? "draftSuccess" : "draftFail";
                this.$message({
                    message: i18n.t(`zhiji.rpa.${hint}`),
                    type: "success"
                });
            }, 0);
        },
        backToList() {
            this.$router.push("/zhijiservice/rpalist");
        }
    }
};
</script>
<style scoped lang="less">
.page-wrapper {
    position: relative;
    height: 100%;
    background: #f2f7fb;
    display: flex;
    flex-direction: column;
    .flow-chart-page-top {
        padding: 10px 16px;
        font-size: 14px;
        background: #fff;
        .return {
            color: #2ec2ff;
            margin-right: 20px;
            cursor: pointer;
        }
        .title-name {
            display: inline-block;
            max-width: 500px;
            vertical-align: text-bottom;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
        .input {
            width: 200px;
            height: 25px;
        }
        /deep/.unvalid {
            input {
                border: 1px solid red;
                &:focus {
                    border-color: red;
                }
            }
        }
        .validationTips{
            color: red;
            margin-left: 20px;
        }
        .edit {
            display: inline-block;
            vertical-align: -9px;
            background: url(/zhiji/images/class-spr.png);
            margin: 0 0 0 5px;
            width: 22px;
            height: 27px;
            background-position: -74px 4px;
            &:hover {
                background-position: -74px -18px;
            }
        }
    }
    .flow-outer {
        flex: 1;
        overflow: auto;
        height: calc(100% - 114px);
    }
}
.flow-chart-page-banner {
    top: 49px;
    margin: 6px 0 0 16px;
    display: inline-flex;
    z-index: 10;
    .flow-auto-sort {
        border: 0.5px solid #d8e4f0;
        border-radius: 0 2px 2px 0;
        background: #fff;
        padding: 5px 16px;
        display: flex;
        align-items: center;
        margin-right: 10px;
        font-size: 13px;
    }
    .pre-num {
        margin-right: 10px;
    }
    .icon-wrapper {
        margin-right: 14px;
        margin-top: 2px;
        display: inline-block;
        font-size: 17px;
        color: #3f4760;
        cursor: pointer;
    }
    .auto-format {
        position: relative;
        margin-left: 7px;
        &::before {
            position: absolute;
            top: -8px;
            left: -7px;
            content: "";
            width: 1px;
            height: 32px;
            background: #d8e4f0;
            display: inline-block;
        }
    }
}
.create-draw {
    margin-left: 15px;
    position: relative;
    cursor: pointer;
    display: inline-flex;
    i {
        position: relative;
        top: -5px;
        margin-right: 4px;
        height: 36px;
        font-style: normal;
        font-size: 28px;
        color: #7a7e8e;
    }
}
.flow-chart-page-bottom {
    padding: 16px 20px;
    background: #fafbfd;
    border-top: 1px solid #d9e4ef;
    .btn-keep {
        margin-left: 30px;
        margin-right: 20px;
    }
}
.el-popper[x-placement^="bottom"] {
    width: 117px;
    margin-top: 1px;
    margin-left: -33px;
}
/deep/.el-button-group .el-button {
    min-width: auto;
    height: 34px;
    border-radius: 0 2px 2px 0;
}
</style>
